import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Pagination from "@mui/material/Pagination"
import CircularProgress from "@mui/material/CircularProgress"
import MoreVert from "@mui/icons-material/MoreVert"
import InfoOutlined from "@mui/icons-material/InfoOutlined"
import Timer from "@mui/icons-material/Timer"
import EditOutlined from "@mui/icons-material/EditOutlined"
import DeleteOutlined from "@mui/icons-material/DeleteOutlined"
import PhotoLibraryOutlined from "@mui/icons-material/PhotoLibraryOutlined"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import queryStringify from "querystringify"
import moment from "moment"
import CreateRoomDialog from "./dialogs/CreateRoomDialog"
import RenameRoomDialog from "./dialogs/RenameRoomDialog"
import RenameExperienceDialog from "./dialogs/RenameExperienceDialog"
import DeleteExperienceDialog from "./dialogs/DeleteExperienceDialog"
import RoomInformationDialog from "./dialogs/RoomInformationDialog"
import ExperienceInformationDialog from "./dialogs/ExperienceInformationDialog"
import DeleteRoomDialog from "./dialogs/DeleteRoomDialog"
import ManageAssetsDialog from "./dialogs/ManageAssetsDialog"
import clipboardCopy from "clipboard-copy"

export default withRouter(
  withTranslation()(
    class AdminBody extends Component {
      state = {
        createRoomOpen: false,
        renameExperienceOpen: false,
        renameRoomOpen: false,
        deleteExperienceOpen: false,
        experienceInformationOpen: false,
        roomInformationOpen: false,
        deleteRoomOpen: false,
        manageAssetsOpen: false,
        anchorEl: false,
        hoveredRow: null,
        loading: false,
        selectedRoom: null,
        error: false,
      }

      fetchRooms = async (offset) => {
        const { experiences, setRooms } = this.props

        if (
          (experiences[0] ||
            queryStringify.parse(window.location.search).experience) &&
          !this.fetchRooms.locked
        ) {
          this.fetchRooms.locked = true

          this.setState({ loading: true })

          let rooms = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/experiences/${
              queryStringify.parse(window.location.search).experience
            }/rooms?password=${localStorage.getItem(
              "password"
            )}&limit=20&offset=${offset}`,
            {
              method: "GET",
              headers: {},
            }
          )
            .then(async (response) => {
              this.setState({ error: null })

              if (response.status !== 200) {
                return []
              }

              return await response.json()
            })
            .catch((error) => {
              this.setState({ error })

              return []
            })

          setRooms(
            rooms,
            queryStringify.parse(window.location.search).experience
          )
          this.setState({ loading: false })

          this.fetchRooms.locked = false
        }
      }

      componentDidMount() {
        const { rooms } = this.props

        this.fetchRooms(0)

        this.unlisten = this.props.history.listen((location) => {
          if (!rooms[queryStringify.parse(location.search).experience]) {
            this.fetchRooms(0)
          }
        })
      }

      componentWillUnmount() {
        this.unlisten()
      }

      render() {
        const {
          t,
          history,
          experiences,
          loading: experienceLoading,
          rooms,
          setRooms,
          setExperiences,
        } = this.props
        const {
          anchorEl,
          hoveredRow,
          createRoomOpen,
          renameExperienceOpen,
          renameRoomOpen,
          deleteExperienceOpen,
          experienceInformationOpen,
          roomInformationOpen,
          deleteRoomOpen,
          manageAssetsOpen,
          loading,
          selectedRoom,
          error,
        } = this.state

        const experience = experiences.find(
          ({ _id }) =>
            _id === queryStringify.parse(window.location.search).experience
        )

        return (
          <>
            <div
              style={{
                width: "calc(100% - 384px)",
                minWidth: "67%",
                backgroundColor: "white",
                boxShadow: "-4px 0px 12px rgba(0, 0, 0, 0.25)",
              }}
              className="notSelectable"
            >
              {experience &&
              rooms[queryStringify.parse(window.location.search).experience] ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      margin: "0 12px 0 16px",
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        lineHeight: "64px",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {experience.name}
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {(() => {
                        const isProtected =
                          experience.permission === "protected"

                        return (
                          <Button
                            style={{
                              borderRadius: "20px",
                              padding: "8px 12px",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                            }}
                            onClick={() =>
                              isProtected
                                ? this.setState({ createRoomOpen: true })
                                : clipboardCopy(
                                    window.location.origin +
                                      "/?experience=" +
                                      experience._id
                                  )
                            }
                          >
                            {t(isProtected ? "Create room" : "Copy link")}
                          </Button>
                        )
                      })()}
                      <IconButton
                        style={{ color: "black" }}
                        onClick={(event) =>
                          this.setState({ anchorEl: event.currentTarget })
                        }
                      >
                        <MoreVert />
                      </IconButton>
                    </div>
                  </div>
                  <div
                    style={{ height: "calc(100% - 64px)", overflow: "auto" }}
                  >
                    {rooms[
                      queryStringify.parse(window.location.search).experience
                    ].length ? (
                      <Table className="notSelectable" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{ fontWeight: 600, width: "30%" }}
                            >{t`Company`}</TableCell>
                            <TableCell
                              style={{
                                textAlign: "center",
                                fontWeight: 600,
                                width: "25%",
                              }}
                            >{t`Created`}</TableCell>
                            <TableCell
                              style={{
                                textAlign: "center",
                                fontWeight: 600,
                                width: "25%",
                              }}
                            >{t`Code`}</TableCell>
                            <TableCell
                              style={{
                                textAlign: "right",
                                fontWeight: 600,
                                paddingRight: "28px",
                                width: "20%",
                              }}
                            >{t`Actions`}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody
                          style={{
                            cursor: "pointer",
                          }}
                          onMouseLeave={() =>
                            this.setState({ hoveredRow: null })
                          }
                        >
                          {rooms[
                            queryStringify.parse(window.location.search)
                              .experience
                          ]
                            .sort((a, b) =>
                              +new Date(a.createdAt) < +new Date(b.createdAt)
                                ? 1
                                : +new Date(a.createdAt) >
                                  +new Date(b.createdAt)
                                ? -1
                                : 0
                            )
                            .map(
                              ({ company, createdAt, roomCode: code, _id }) => (
                                <TableRow
                                  key={_id}
                                  onMouseOver={() => {
                                    if (hoveredRow !== code) {
                                      this.setState({ hoveredRow: code })
                                    }
                                  }}
                                  style={{
                                    backgroundColor:
                                      hoveredRow === code
                                        ? "rgba(0, 0, 0, 0.04)"
                                        : "unset",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    history.push(
                                      `/admin?experience=${experience._id}&room=${_id}`
                                    )
                                  }
                                >
                                  <TableCell>{company}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {moment(createdAt).format("D MMM YYYY")}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {code
                                      .toString()
                                      .padStart(6, 0)
                                      .toString()
                                      .slice(0, -3) +
                                      "-" +
                                      code
                                        .toString()
                                        .padStart(6, 0)
                                        .toString()
                                        .substr(-3)}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      textAlign: "right",
                                      padding: "8px 16px",
                                    }}
                                  >
                                    <IconButton
                                      onMouseOver={(event) => {
                                        event.stopPropagation()
                                        if (hoveredRow !== null)
                                          this.setState({ hoveredRow: null })
                                      }}
                                      onClick={(event) => {
                                        event.stopPropagation()

                                        this.setState({
                                          roomInformationOpen: true,
                                          selectedRoom: _id,
                                        })
                                      }}
                                    >
                                      <Timer style={{ color: "black" }} />
                                    </IconButton>
                                    <IconButton
                                      onMouseOver={(event) => {
                                        event.stopPropagation()
                                        this.setState({ hoveredRow: null })
                                      }}
                                      onClick={(event) => {
                                        event.stopPropagation()

                                        this.setState({
                                          deleteRoomOpen: true,
                                          selectedRoom: _id,
                                        })
                                      }}
                                    >
                                      <DeleteOutlined
                                        style={{ color: "black" }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    ) : error ? (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="h4"
                          style={{
                            fontSize: "30px",
                            fontWeight: 600,
                            margin: "0 32px 8px 32px",
                            color: "#181818",
                          }}
                        >
                          {t`Something went wrong`}
                        </Typography>
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: 300,
                            margin: "0 32px",
                            color: "#181818",
                          }}
                        >{t`Check your connection and try again`}</Typography>
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="h4"
                          style={{
                            fontSize: "30px",
                            fontWeight: 600,
                            margin: "0 32px 8px 32px",
                            color: "#181818",
                          }}
                        >
                          {t`No rooms`}
                        </Typography>
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: 300,
                            margin: "0 32px",
                            color: "#181818",
                          }}
                        >{t`Create one to get started`}</Typography>
                      </div>
                    )}
                    {experience.roomCount > 20 && (
                      <div
                        style={{
                          height: "56px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Pagination
                          count={Math.ceil(experience.roomCount / 20)}
                          onChange={(_, page) =>
                            this.fetchRooms((page - 1) * 20)
                          }
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : experienceLoading || loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    style={{
                      fontSize: "30px",
                      fontWeight: 600,
                      margin: "0 32px 8px 32px",
                      color: "#181818",
                    }}
                  >
                    {t`No available experiences`}
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: 300,
                      margin: "0 32px",
                      color: "#181818",
                    }}
                  >{t`Upload one to get started`}</Typography>
                </div>
              )}
            </div>
            <Menu
              open={anchorEl}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => this.setState({ anchorEl: null })}
              MenuListProps={{ disablePadding: true }}
            >
              <MenuItem
                style={{ padding: "12px 16px" }}
                onClick={() =>
                  this.setState({
                    experienceInformationOpen: true,
                    anchorEl: null,
                  })
                }
              >
                <ListItemIcon>
                  <InfoOutlined style={{ color: "black" }} />
                </ListItemIcon>
                <Typography
                  variant="inherit"
                  noWrap
                >{t`Information`}</Typography>
              </MenuItem>
              <MenuItem
                style={{ padding: "12px 16px" }}
                onClick={() =>
                  this.setState({ renameExperienceOpen: true, anchorEl: null })
                }
              >
                <ListItemIcon>
                  <EditOutlined style={{ color: "black" }} />
                </ListItemIcon>
                <Typography variant="inherit" noWrap>{t`Rename`}</Typography>
              </MenuItem>
              <MenuItem
                style={{ padding: "12px 16px" }}
                onClick={() =>
                  this.setState({ manageAssetsOpen: true, anchorEl: null })
                }
              >
                <ListItemIcon>
                  <PhotoLibraryOutlined style={{ color: "black" }} />
                </ListItemIcon>
                <Typography
                  variant="inherit"
                  noWrap
                >{t`Manage assets`}</Typography>
              </MenuItem>
              <MenuItem
                style={{ padding: "12px 16px" }}
                onClick={() =>
                  this.setState({ deleteExperienceOpen: true, anchorEl: null })
                }
              >
                <ListItemIcon>
                  <DeleteOutlined style={{ color: "black" }} />
                </ListItemIcon>
                <Typography variant="inherit" noWrap>{t`Delete`}</Typography>
              </MenuItem>
            </Menu>
            <CreateRoomDialog
              open={createRoomOpen}
              close={() => this.setState({ createRoomOpen: false })}
              addRoom={(room) =>
                setRooms(
                  [
                    ...rooms[
                      queryStringify.parse(window.location.search).experience
                    ],
                    room,
                  ],
                  queryStringify.parse(window.location.search).experience
                )
              }
            />
            <DeleteExperienceDialog
              open={deleteExperienceOpen}
              close={() => this.setState({ deleteExperienceOpen: false })}
              setExperiences={setExperiences}
              experiences={experiences}
            />
            <RoomInformationDialog
              key={"completion-times-" + selectedRoom}
              open={roomInformationOpen}
              close={() => this.setState({ roomInformationOpen: false })}
              experienceId={
                queryStringify.parse(window.location.search).experience
              }
              roomId={selectedRoom}
            />
            <ExperienceInformationDialog
              open={experienceInformationOpen}
              close={() => this.setState({ experienceInformationOpen: false })}
              experienceId={
                queryStringify.parse(window.location.search).experience
              }
            />
            <DeleteRoomDialog
              open={deleteRoomOpen}
              close={() => this.setState({ deleteRoomOpen: false })}
              roomId={selectedRoom}
              deleteRoom={(room) =>
                setRooms(
                  rooms[
                    queryStringify.parse(window.location.search).experience
                  ].filter(({ _id }) => _id !== room),
                  queryStringify.parse(window.location.search).experience
                )
              }
            />
            <RenameRoomDialog
              roomId={selectedRoom}
              name={
                rooms[
                  queryStringify.parse(window.location.search).experience
                ]?.find(({ _id }) => _id === selectedRoom)?.company
              }
              open={renameRoomOpen}
              close={() => this.setState({ renameRoomOpen: false })}
              setRooms={setRooms}
              rooms={
                rooms[queryStringify.parse(window.location.search).experience]
              }
            />
            {experience && (
              <>
                <ManageAssetsDialog
                  open={manageAssetsOpen}
                  close={() => this.setState({ manageAssetsOpen: false })}
                  experience={experience}
                  setExperiences={setExperiences}
                  experiences={experiences}
                />
                <RenameExperienceDialog
                  name={experience.name}
                  open={renameExperienceOpen}
                  close={() => this.setState({ renameExperienceOpen: false })}
                  setExperiences={setExperiences}
                  experiences={experiences}
                />
              </>
            )}
          </>
        )
      }
    }
  )
)
